// extracted by mini-css-extract-plugin
module.exports = {"rightBarFollowButton":"FollowingButton_rightBarFollowButton__3dy94","loading":"FollowingButton_loading__2s9cZ"};